import * as yup from "yup";
import { t } from "i18next";
import { installationConfig } from "@/shared/constants/installation-config";
import { testPhoneNumber } from "@/shared/yup";
import type { RegisterInitRequest } from "@/services/api";

export const getUserRegistrationSchema = () =>
  yup.object<RegisterInitRequest>().shape({
    firstName: yup.string().required(t("validation.required")),
    lastName: yup.string().required(t("validation.required")),
    phoneNumber: yup
      .string()
      .required(t("validation.required"))
      .test("phone-format", function (value) {
        return testPhoneNumber(this, value, installationConfig.phoneRegex);
      }),
    email: yup
      .string()
      .required(t("validation.required"))
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, t("validation.invalidEmail")),
    password: yup
      .string()
      .required(t("validation.required"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?"-:{}|<>]).{8,}$/,
        t("validation.passwordContain"),
      ),
    confirmPassword: yup
      .string()
      .required(t("validation.required"))
      .oneOf([yup.ref("password")], t("validation.passwordMustMatch")),
    isAgree: yup.boolean(),
  });
